/**
 * The data may contain order (legacy) or orderID (new).
 * TODO: A week or so after PROP-2458 is released, remove the legacy handling.
 * It's kept in for now in case a client has some queued online tasks when we release the changes.
 * Quite unlikely, but safer this way.
 *
 * @param {OnlineTask|{data: {order?:Order, orderID?:number, payments:Payment[]}}} task
 * @param {PaymentService} paymentService
 *
 * @returns {Promise<Payment[]>}
 */
const addPaymentsTaskHandler = (task, paymentService) => {
    return paymentService.storePaymentsForOrder(
        task.data.order ? task.data.order.ID : task.data.orderID,
        task.data.payments
    );
};

module.exports = addPaymentsTaskHandler;
